import { useAppConfig } from "@/api/app-config/useAppConfig";

import type { IExternalIntegrationsProviderEnabledResult } from "./types";

export const useExternalIntegrationsProviderEnabled =
  (): IExternalIntegrationsProviderEnabledResult => {
    const { data, isLoading, isError } = useAppConfig();
    return {
      isEnabled: data?.isExternalIntegrationsProviderEnabled ?? false,
      isLoading,
      isError,
    };
  };
